import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { functions } from "@poseidon/firebase/firebase";
import { useState } from "react";
import { useHttpsCallable } from "react-firebase-hooks/functions";

export const useStartIdvCheck = () => {
  const [loading, setLoading] = useState(false);
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const [complete, setComplete] = useState(false);

  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "startIdvCheck"
  );

  const startIdvCheck = async ({
    sailorId,
    issuingCountry,
    documentType,
  }: {
    [key: string]: string;
  }) => {
    try {
      setLoading(true);
      const response = await executeCallable({
        sailorId,
        issuingCountry,
        documentType,
      });

      setLoading(false);

      if ((response as any)?.data.error) {
        setComplete(false);
        return setError((response as any)?.data.error);
      }

      if ((response as any).data?.success) {
        setComplete(true);
        setToast("ID&V check created");
      }
    } catch (err) {
      setComplete(false);
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Unknown error");
      }
    }
    setLoading(false);
  };

  return { startIdvCheck, loading, complete };
};
